import React from 'react';
import ActorIcon from '@resources/js/components/ActorIcon/ActorIcon';

type BuildsClassAndSpecBoxSpec = {
  name: string;
  fullType: string;
  buildsPath: string;
};

export type BuildsClassAndSpecBoxProps = {
  className: string;
  cssClassName: string;
  specs: Array<BuildsClassAndSpecBoxSpec>;
  LinkWrapper: (props: {
    children: React.ReactNode;
    href: string;
  }) => JSX.Element;
};

export default function BuildsClassAndSpecBox({
  className,
  cssClassName,
  specs,
  LinkWrapper,
}: BuildsClassAndSpecBoxProps): JSX.Element {
  return (
    <div className={`builds-class-and-spec-box ${cssClassName}`}>
      <div
        className={`builds-class-and-spec-box__class-title ${cssClassName}-gradient-bg`}
      >
        <LinkWrapper href={specs[0].buildsPath}>
          <div
            className={'builds-class-and-spec-box__class-title__link-container'}
          >
            <div className={'builds-class-and-spec-box__class-icon'}>
              <ActorIcon
                type={cssClassName}
                size={28}
                rounded={false}
                bordered={true}
              />
            </div>
            <div>{className}</div>
          </div>
        </LinkWrapper>
      </div>
      <div
        className={`builds-class-and-spec-box__class-specs ${cssClassName}-gradient-bg-dark`}
      >
        {specs.map((spec) => (
          <div
            key={spec.name}
            className={'builds-class-and-spec-box__class-specs__spec'}
          >
            <LinkWrapper href={spec.buildsPath}>
              <div
                className={
                  'builds-class-and-spec-box__class-specs__link-container'
                }
              >
                <div className={'builds-class-and-spec-box__spec-icon'}>
                  <ActorIcon
                    type={spec.fullType}
                    size={19}
                    rounded={false}
                    bordered={true}
                  />
                </div>
                <div>{spec.name}</div>
              </div>
            </LinkWrapper>
          </div>
        ))}
      </div>
    </div>
  );
}
